import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import EmployerTestimonialCarousel from './EmployerTestimonialCarousel';
import EmployerSignupForm from '../EmployerSignupForm';
import peopleDiscussingImg from '../../../../assets/images/add-a-project-bold.svg';
import pioneeringActiveLogo from '../../../../assets/images/testimonials/pioneering-active.png';
import pioneeringInactiveLogo from '../../../../assets/images/testimonials/pioneering-inactive.png';
import cyclerionActiveLogo from '../../../../assets/images/testimonials/cyclerion-active.png';
import cyclerionInactiveLogo from '../../../../assets/images/testimonials/cyclerion-inactive.png';
import rhythmActiveLogo from '../../../../assets/images/testimonials/rhythm-active.png';
import rhythmInactiveLogo from '../../../../assets/images/testimonials/rhythm-inactive.png';

const employerTestimonials = () => {
  const pioneering = {
    managerName: 'Alec Reynolds',
    managerTitle: 'SVP, Portfolio Strategy & Operations',
    body: 'Clora is a great service. They have identified a '
          + 'number of experts for us. They know us and our '
          + 'business well and work hard to understand the '
          + 'talent we need, access their large network, '
          + 'and quickly find the right match. '
          + 'We have been impressed.',
    activeLogo: pioneeringActiveLogo,
    inactiveLogo: pioneeringInactiveLogo,
    logoHeight: 24,
    logoWidth: 125,
  };

  const cyclerion = {
    managerName: 'Chris Wright',
    managerTitle: 'Former Chief Medical Officer',
    body: 'We have hired several excellent consultants for our '
          + 'teams. The process has been easy, efficient and '
          + 'quick in all cases.  [...] we found exactly the '
          + 'right profiles for the areas where we needed '
          + 'additional capacity and subject matter '
          + 'expertise across a range of disciplines [...]. '
          + 'Our consultants work seamlessly with our internal staff '
          + 'and the culture fit has been exceptional.',
    activeLogo: cyclerionActiveLogo,
    inactiveLogo: cyclerionInactiveLogo,
    logoHeight: 30,
    logoWidth: 70,
  };

  const rhythm = {
    managerName: 'Satej Bhandarkar',
    managerTitle: 'SVP, Program Management & Strategy',
    body: 'Our consultant has been great to work with at '
          + 'every stage of this project and we couldn\'t be '
          + 'more proud of the work she\'s been able to produce '
          + 'for our team [...] We would be in a tough spot without her. '
          + 'Thanks again for helping us find this valuable team member.',
    activeLogo: rhythmActiveLogo,
    inactiveLogo: rhythmInactiveLogo,
    logoHeight: 20,
    logoWidth: 80,
  };

  return ([pioneering, cyclerion, rhythm]);
};

const renderEmployerTestimonials = () => (
  <div className="centered-testimonials-panel">
    <EmployerTestimonialCarousel
      testimonials={employerTestimonials()}
      interval={15000}
    />
  </div>
);

const renderPeopleDiscussingImage = () => (
  <img
    alt="people discussing"
    className="people-discussing d-none d-md-block"
    src={peopleDiscussingImg}
  />
);

const referralPanel = (referrer, company) => (
  <div>
    <h1 className="hero-header registration-welcome-title">
      {referrer}
      {' '}
      wants you to meet Clora.
    </h1>
    <div className="body-text-1 registration-welcome-body">
      Your friend,
      {' '}
      {referrer}
      , thinks you are a great fit for Clora. Join the platform,
      like
      {' '}
      {company}
      , and start matching your on-demand project needs with talented
      life-science experts!
    </div>
    {renderPeopleDiscussingImage()}
  </div>
);

function EmployerSignupPanel({
  csrfToken,
  invitedEmail,
  company,
  referralToken,
  referrer,
  referrerCompany,
  signInUrl,
  googleOmniauthUrl,
  msOmniauthUrl,
  header,
  showReferralPanel,
  extraParams,
  showTestimonials,
  location,
  inviterId,
  projectResourceId,
}) {
  return (
    <div className="employer-registration">
      <Row>
        { !(referrer && referralToken && referrerCompany)
        && <div className="quarter-circle-bottom-left d-none d-md-block" /> }
        { showReferralPanel
        && (
        <Col xs={12} sm={6}>
          <div className="left-panel">
            { referrer && referralToken && referrerCompany
              ? referralPanel(referrer, referrerCompany)
              : (
                <div className="d-none d-md-block">
                  {' '}
                  {renderEmployerTestimonials()}
                  {' '}
                </div>
              ) }
          </div>
        </Col>
        )}
        <Col xs sm>
          <div className="employer-form">
            <h1 className="hero-header">
              {header}
            </h1>
            <EmployerSignupForm
              csrfToken={csrfToken}
              invitedEmail={invitedEmail}
              company={company}
              referralToken={referralToken}
              submitButtonText="Sign Up as an Employer"
              signInUrl={signInUrl}
              location={location}
              googleOmniauthUrl={googleOmniauthUrl}
              msOmniauthUrl={msOmniauthUrl}
              extraParams={extraParams}
              inviterId={inviterId}
              projectResourceId={projectResourceId}
            />
            {showTestimonials
            && (
            <div className="mt-5 d-block d-md-none">
              <div className="quarter-circle-bottom-left" />
              {renderEmployerTestimonials()}
            </div>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
}

EmployerSignupPanel.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  invitedEmail: PropTypes.string,
  company: PropTypes.string,
  referralToken: PropTypes.string,
  referrer: PropTypes.string,
  referrerCompany: PropTypes.string,
  signInUrl: PropTypes.string.isRequired,
  googleOmniauthUrl: PropTypes.string,
  msOmniauthUrl: PropTypes.string,
  header: PropTypes.string,
  showReferralPanel: PropTypes.bool,
  extraParams: PropTypes.shape({}),
  showTestimonials: PropTypes.bool,
  location: PropTypes.string,
  inviterId: PropTypes.string,
  projectResourceId: PropTypes.string,
};

EmployerSignupPanel.defaultProps = {
  invitedEmail: null,
  company: null,
  referralToken: null,
  referrer: null,
  referrerCompany: null,
  header: 'Switch to the simplest way of hiring',
  showReferralPanel: true,
  extraParams: {},
  googleOmniauthUrl: null,
  msOmniauthUrl: null,
  showTestimonials: true,
  location: 'Registration Page',
  inviterId: null,
  projectResourceId: null,
};

export default EmployerSignupPanel;
